import {
  createMockDriver,
  loadMockDriver,
  saveMockDriver,
} from "../../features/driver/mockIdentity";
import { mockLocationFor } from "../../features/location/coarseLocation";
import { targetSpeedMph } from "../../features/traffic/trafficModel";
import type { DriverProfile } from "../../types/traffic";
import type {
  HeartbeatInput,
  HeartbeatResponse,
  JoinInput,
  JoinResponse,
  TrafficApi,
} from "./TrafficApi";

export class OfflineTrafficApi implements TrafficApi {
  private profile: DriverProfile = loadMockDriver() ?? createMockDriver();
  private sessionDistanceMiles = 0;

  public join(_input: JoinInput = {}): Promise<JoinResponse> {
    this.sessionDistanceMiles = 0;
    saveMockDriver(this.profile);
    const now = new Date().toISOString();
    return Promise.resolve({
      sessionId: `offline_${crypto.randomUUID().replaceAll("-", "")}`,
      driver: this.profile,
      location: mockLocationFor(this.profile.plate),
      traffic: {
        activeDriverCount: 1,
        targetSpeedMph: targetSpeedMph(1),
        state: "CLEAR",
        snapshotAt: now,
      },
      cohort: { id: "offline", channel: "offline" },
      serverTime: now,
      heartbeatIntervalSeconds: 30,
      configurationRevision: 1,
      features: {
        realtimeMode: "offline",
        garageEnabled: true,
        customPlatesEnabled: false,
        sharingEnabled: true,
      },
    });
  }

  public heartbeat(input: HeartbeatInput): Promise<HeartbeatResponse> {
    const acceptedDistance = Math.max(0, input.odometerDeltaMiles);
    this.sessionDistanceMiles += acceptedDistance;
    this.profile = {
      ...this.profile,
      ...input.appearance,
      odometerMiles: this.profile.odometerMiles + acceptedDistance,
    };
    saveMockDriver(this.profile);
    const now = new Date().toISOString();
    return Promise.resolve({
      traffic: {
        activeDriverCount: 1,
        targetSpeedMph: targetSpeedMph(1),
        state: "CLEAR",
        snapshotAt: now,
      },
      configurationRevision: 1,
      realtimeMode: "offline",
      heartbeatIntervalSeconds: 30,
      sessionDistanceMiles: this.sessionDistanceMiles,
    });
  }

  public leave(): Promise<void> {
    saveMockDriver(this.profile);
    return Promise.resolve();
  }
}
